// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site__header {
    top: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.menu__button {
    color: var(--text-color);
}

.menu__button:focus,
.menu__button:hover {
    color: var(--text-color);
    box-shadow: unset;
}

.menu__button svg {
    width: 2em;
    height: 2em;
    fill: var(--text-color-2);
    color: var(--text-color-2);
}

.nav_ac {
    padding: 5px 15px;
    margin: 0;
    border: unset;
    background: var(--primary-color);
    font-size: 1.25rem;
    font-family: Marcellus;
    color: var(--text-color-2);
    line-height: 2;
    height: 50px;
    font-weight: bold;
    z-index: 1000;
}

.nav_ac:hover {
    color: var(--text-color-2);
}

.br-top,
.br-bottom,
.br-right,
.br-left {
    position: fixed;
    z-index: 999999;
    background: var(--primary-color);
}

.br-top {
    top: 0;
    height: 10px;
    left: 0;
    width: 100%;
}

.br-bottom {
    bottom: 0;
    left: 0;
    height: 10px;
    width: 100%;
}

.br-right {
    width: 10px;
    right: 0;
    top: 0;
    height: 100%;
}

.br-left {
    width: 10px;
    left: 0;
    top: 0;
    height: 100%;
}

.cortina__wrapper-menu {
    position: relative;
    width: 100%;
    padding-top: 5em;
    padding-bottom: 3em;
    height: 100%;
    overflow-y: auto;
}

.site__navigation {
    height: 100%;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
    visibility: hidden;
}

.menu__opend {
    visibility: visible !important;
}

.main__menu_ul,
.menu_right {
    opacity: 0;
    position: relative;
    transition: 0.5s;
    transition-delay: 0s;
    visibility: hidden;
    z-index: 100;
}

.menu_right {
    text-align: center;
}

.site__navigation.menu__opend .main__menu_ul,
.site__navigation.menu__opend .menu_right {
    opacity: 1;
    transition-delay: 0.6s;
    visibility: visible;
}

.site__navigation .main__menu_ul li {
    list-style: none;
    margin: 10px 0;
}

.site__navigation .main__menu_ul li a {
    color: var(--text-color);
    display: block;
    font-size: 2.5rem;
    text-decoration: none;
}

.bg__menu {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: var(--primary-color);
    will-change: transform;
    transform: translateY(-100%);
    transition: .5s ease all;
}

.menu__opend .bg__menu {
    transform: translateY(0);
}

.menu__wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden auto;
}

.the_menu {
    padding-top: 20vh;
    padding-bottom: 20vh;
    padding-left: 0;
}

@media (min-width: 992px) {
    .menu__container {
        margin-left: 33.3333%;
    }
    .the_menu {
        padding-top: 10vh;
        padding-bottom: 10vh;
    }
}

.the_menu .menu_item>a {
    color: var(--text-color-2);
    line-height: 1;
    font-size: 2rem;
    display: inline-block;
    position: relative;
    transition: color 250ms cubic-bezier(0, 0, 0.58, 1) 0s;
    padding: 4px 0px;
    text-decoration: none;
    font-family: Marcellus;
}

.the_menu .menu_item>a:hover {
    color: var(--text-color-3);
}

@media (min-width: 768px) {
    .the_menu .menu_item>a {
        font-size: 4.8vw;
    }
}

.menu_footer {
    bottom: 0;
    font-family: Marcellus;
    font-size: 14px;
    background: var(--primary-color);
}

.menu_footer a {
    color: var(--text-color-2);
    margin-right: 10px;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/header/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;;IAII,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,MAAM;IACN,YAAY;IACZ,OAAO;IACP,WAAW;AACf;;AAEA;IACI,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,sDAAsD;IACtD,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".site__header {\n    top: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.menu__button {\n    color: var(--text-color);\n}\n\n.menu__button:focus,\n.menu__button:hover {\n    color: var(--text-color);\n    box-shadow: unset;\n}\n\n.menu__button svg {\n    width: 2em;\n    height: 2em;\n    fill: var(--text-color-2);\n    color: var(--text-color-2);\n}\n\n.nav_ac {\n    padding: 5px 15px;\n    margin: 0;\n    border: unset;\n    background: var(--primary-color);\n    font-size: 1.25rem;\n    font-family: Marcellus;\n    color: var(--text-color-2);\n    line-height: 2;\n    height: 50px;\n    font-weight: bold;\n    z-index: 1000;\n}\n\n.nav_ac:hover {\n    color: var(--text-color-2);\n}\n\n.br-top,\n.br-bottom,\n.br-right,\n.br-left {\n    position: fixed;\n    z-index: 999999;\n    background: var(--primary-color);\n}\n\n.br-top {\n    top: 0;\n    height: 10px;\n    left: 0;\n    width: 100%;\n}\n\n.br-bottom {\n    bottom: 0;\n    left: 0;\n    height: 10px;\n    width: 100%;\n}\n\n.br-right {\n    width: 10px;\n    right: 0;\n    top: 0;\n    height: 100%;\n}\n\n.br-left {\n    width: 10px;\n    left: 0;\n    top: 0;\n    height: 100%;\n}\n\n.cortina__wrapper-menu {\n    position: relative;\n    width: 100%;\n    padding-top: 5em;\n    padding-bottom: 3em;\n    height: 100%;\n    overflow-y: auto;\n}\n\n.site__navigation {\n    height: 100%;\n    left: 0;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    visibility: hidden;\n}\n\n.menu__opend {\n    visibility: visible !important;\n}\n\n.main__menu_ul,\n.menu_right {\n    opacity: 0;\n    position: relative;\n    transition: 0.5s;\n    transition-delay: 0s;\n    visibility: hidden;\n    z-index: 100;\n}\n\n.menu_right {\n    text-align: center;\n}\n\n.site__navigation.menu__opend .main__menu_ul,\n.site__navigation.menu__opend .menu_right {\n    opacity: 1;\n    transition-delay: 0.6s;\n    visibility: visible;\n}\n\n.site__navigation .main__menu_ul li {\n    list-style: none;\n    margin: 10px 0;\n}\n\n.site__navigation .main__menu_ul li a {\n    color: var(--text-color);\n    display: block;\n    font-size: 2.5rem;\n    text-decoration: none;\n}\n\n.bg__menu {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: var(--primary-color);\n    will-change: transform;\n    transform: translateY(-100%);\n    transition: .5s ease all;\n}\n\n.menu__opend .bg__menu {\n    transform: translateY(0);\n}\n\n.menu__wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden auto;\n}\n\n.the_menu {\n    padding-top: 20vh;\n    padding-bottom: 20vh;\n    padding-left: 0;\n}\n\n@media (min-width: 992px) {\n    .menu__container {\n        margin-left: 33.3333%;\n    }\n    .the_menu {\n        padding-top: 10vh;\n        padding-bottom: 10vh;\n    }\n}\n\n.the_menu .menu_item>a {\n    color: var(--text-color-2);\n    line-height: 1;\n    font-size: 2rem;\n    display: inline-block;\n    position: relative;\n    transition: color 250ms cubic-bezier(0, 0, 0.58, 1) 0s;\n    padding: 4px 0px;\n    text-decoration: none;\n    font-family: Marcellus;\n}\n\n.the_menu .menu_item>a:hover {\n    color: var(--text-color-3);\n}\n\n@media (min-width: 768px) {\n    .the_menu .menu_item>a {\n        font-size: 4.8vw;\n    }\n}\n\n.menu_footer {\n    bottom: 0;\n    font-family: Marcellus;\n    font-size: 14px;\n    background: var(--primary-color);\n}\n\n.menu_footer a {\n    color: var(--text-color-2);\n    margin-right: 10px;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
